var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 6,
    fill: "#F0F0F0"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4350_53493)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.16667 11.25L7.83333 9.58333L12.4167 14.1667L15.3333 11.25L17.8333 13.75V6.16667H6.16667V11.25ZM6.16667 13.6075V17.8333H8.75L11.2383 15.3458L7.83333 11.9408L6.16667 13.6075ZM11.1075 17.8333H17.8333V16.1075L15.3333 13.6075L11.1075 17.8333ZM5.33333 4.5H18.6667C18.8877 4.5 19.0996 4.5878 19.2559 4.74408C19.4122 4.90036 19.5 5.11232 19.5 5.33333V18.6667C19.5 18.8877 19.4122 19.0996 19.2559 19.2559C19.0996 19.4122 18.8877 19.5 18.6667 19.5H5.33333C5.11232 19.5 4.90036 19.4122 4.74408 19.2559C4.5878 19.0996 4.5 18.8877 4.5 18.6667V5.33333C4.5 5.11232 4.5878 4.90036 4.74408 4.74408C4.90036 4.5878 5.11232 4.5 5.33333 4.5V4.5ZM14.9167 10.3333C14.5851 10.3333 14.2672 10.2016 14.0328 9.96722C13.7984 9.7328 13.6667 9.41485 13.6667 9.08333C13.6667 8.75181 13.7984 8.43387 14.0328 8.19945C14.2672 7.96503 14.5851 7.83333 14.9167 7.83333C15.2482 7.83333 15.5661 7.96503 15.8005 8.19945C16.035 8.43387 16.1667 8.75181 16.1667 9.08333C16.1667 9.41485 16.035 9.7328 15.8005 9.96722C15.5661 10.2016 15.2482 10.3333 14.9167 10.3333V10.3333Z",
    fill: "#454545"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4350_53493"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(2 2)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage);
export default __webpack_public_path__ + "static/media/image.3541a76bcd733b63d869dd88c3e7051d.svg";
export { ForwardRef as ReactComponent };